'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _dec3, _class, _class2, _temp2;

var _reactRedux = require('react-redux');

var _reduxAsyncConnect = require('redux-async-connect');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _LoginSignup = require('./LoginSignup.scss');

var _LoginSignup2 = _interopRequireDefault(_LoginSignup);

var _session = require('redux/modules/session');

var _profile = require('redux/modules/profile');

var _reactFacebookLogin = require('react-facebook-login');

var _reactFacebookLogin2 = _interopRequireDefault(_reactFacebookLogin);

var _reactGoogleLogin = require('react-google-login');

var _reactGoogleLogin2 = _interopRequireDefault(_reactGoogleLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  SocialAuthen: {
    displayName: 'SocialAuthen'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/Nav/SocialAuthen.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

// import MobileConnectButton from 'components/MobileConnectButton/MobileConnectButton';

var SocialAuthen = _wrapComponent('SocialAuthen')((_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    return dispatch((0, _profile.load)());
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.session.user,
    messages: state.language.messages
  };
}, { facebookLogin: _session.facebookLogin, googleLogin: _session.googleLogin, mobileConnectLogin: _session.mobileConnectLogin, loadProfile: _profile.load }), _dec3 = (0, _reactCssModules2.default)(_LoginSignup2.default), _dec(_class = _dec2(_class = _dec3(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(SocialAuthen, _Component);

  function SocialAuthen() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SocialAuthen);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = SocialAuthen.__proto__ || (0, _getPrototypeOf2.default)(SocialAuthen)).call.apply(_ref2, [this].concat(args))), _this), _this.getProviders = function () {
      return _this.props.user.providers.map(function (provider) {
        return provider.name;
      });
    }, _this.facebookCallback = function (response) {
      if (!response.accessToken) return;
      _this.props.facebookLogin(response.accessToken).then(function () {
        return _this.props.loadProfile();
      });
    }, _this.googleCallback = function (response) {
      _this.props.googleLogin(response.getAuthResponse().id_token).then(function () {
        return _this.props.loadProfile();
      });
    }, _this.mobileConnectCallback = function (response) {
      _this.props.mobileConnectLogin(response).then(function () {
        return _this.props.loadProfile();
      });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SocialAuthen, [{
    key: 'render',
    value: function render() {
      var messages = this.props.messages;

      var providers = this.getProviders();
      return _react3.default.createElement(
        'div',
        { style: { 'margin-bottom': '20px' } },
        _react3.default.createElement(
          'div',
          { styleName: 'buttons', ref: 'social' },
          providers.indexOf('facebook') < 0 && _react3.default.createElement(_reactFacebookLogin2.default, {
            cssClass: _LoginSignup2.default['btn-facebook'],
            appId: '512381822169849',
            callback: this.facebookCallback,
            scope: 'public_profile, email',
            textButton: messages['dashboard.setting.social.facebook'] }),
          providers.indexOf('google') < 0 && _react3.default.createElement(
            'div',
            null,
            _react3.default.createElement(_reactGoogleLogin2.default, {
              className: _LoginSignup2.default['btn-google'],
              clientId: '1087964454414-pnm60fbegh6cec6m0rvk9eienko254pj.apps.googleusercontent.com',
              onSuccess: this.googleCallback,
              onFailure: function onFailure() {},
              buttonText: messages['dashboard.setting.social.google'] })
          )
        )
      );
    }
  }]);
  return SocialAuthen;
}(_react2.Component), _class2.propTypes = {
  user: _react2.PropTypes.object,
  messages: _react2.PropTypes.object,
  facebookLogin: _react2.PropTypes.func,
  googleLogin: _react2.PropTypes.func,
  mobileConnectLogin: _react2.PropTypes.func,
  weiboLogin: _react2.PropTypes.func,
  loadProfile: _react2.PropTypes.func
}, _temp2)) || _class) || _class) || _class));

exports.default = SocialAuthen;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Nav/SocialAuthen.js
// module id = 1571
// module chunks = 47